/**
 * UsageContent - 食用方法渲染组件
 */

import React from 'react';
import { getProxyUrl } from '../../utils/urlProxy';

export default function UsageContent({ data, mode = 'view', templateType }) {
  if (!data) return null;

  const isStandardTemplate = templateType === 'standard-food-label';
  const isBlueWhiteTemplate = templateType === 'blue-white-template';
  
  // 获取标题配置
  const titleConfig = data.titleConfig || {};
  const shouldShowCustomTitle = titleConfig.enabled && (titleConfig.chinese || titleConfig.english);
  
  // 渲染标题
  const renderTitle = () => {
    if (shouldShowCustomTitle) {
      const HeadingTag = isBlueWhiteTemplate ? 'h3' : 'h3';
      const baseClass = isBlueWhiteTemplate ? 'content-section-heading blue-white-title' : 'content-section-heading';
      return (
        <HeadingTag
          className={baseClass}
          style={{
            backgroundColor: titleConfig.bgColor || (isBlueWhiteTemplate ? '#1e90ff' : undefined),
            color: titleConfig.textColor || (isBlueWhiteTemplate ? '#ffffff' : undefined)
          }}
        >
          {titleConfig.english && (
            <div className="blue-white-title-en">{titleConfig.english}</div>
          )}
          <div className="blue-white-title-cn">{titleConfig.chinese || '食用方法'}</div>
        </HeadingTag>
      );
    }

    if (isStandardTemplate || isBlueWhiteTemplate) {
      return <h3 className="content-section-heading">食用方法</h3>;
    }

    return null;
  };

  if (isBlueWhiteTemplate) {
    // 如果用户设置了背景色，优先使用用户设置的颜色，覆盖CSS默认值
    const bgColor = data.backgroundColor && data.backgroundColor !== 'transparent' 
      ? data.backgroundColor 
      : undefined;
    
    return (
      <>
        {renderTitle()}
        <div 
          className="label-content-usage" 
          style={{ 
            backgroundColor: bgColor || undefined,
            background: bgColor || undefined  // 使用background确保覆盖CSS中的background属性
          }}
        >
          {data.title && (
            <div className="usage-title" dangerouslySetInnerHTML={{ __html: data.title }} />
          )}
          {data.video && (() => {
            const videoUrl = typeof data.video === 'string' ? data.video : data.video.url;
            const proxyVideoUrl = getProxyUrl(videoUrl);
            const posterUrl = data.videoOptions && data.videoOptions.poster ? getProxyUrl(data.videoOptions.poster) : undefined;
            return (
              <video
                src={proxyVideoUrl}
                className="usage-video"
                controls={(data.videoOptions ? data.videoOptions.controls !== false : true)}
                autoPlay={!!(data.videoOptions && data.videoOptions.autoplay)}
                muted={!!(data.videoOptions && data.videoOptions.muted)}
                loop={!!(data.videoOptions && data.videoOptions.loop)}
                poster={posterUrl}
                style={{
                  borderRadius: data.videoStyle && data.videoStyle.radius ? data.videoStyle.radius : 0,
                  border: data.videoStyle && data.videoStyle.borderWidth ? `${data.videoStyle.borderWidth}px solid ${data.videoStyle.borderColor || '#e8eaed'}` : 'none',
                  height: data.videoStyle && data.videoStyle.height ? data.videoStyle.height : undefined
                }}
                onError={(e) => {
                  console.error('视频加载失败:', videoUrl);
                }}
              />
            );
          })()}
        </div>
      </>
    );
  }
  return (
    <div
      className="label-content-usage"
      style={{
        backgroundColor: (isStandardTemplate || isBlueWhiteTemplate) ? undefined : (data.backgroundColor || '#1e90ff')
      }}
    >
      {(isStandardTemplate || isBlueWhiteTemplate) && renderTitle()}
      {data.title && (
        <div
          className="usage-title"
          dangerouslySetInnerHTML={{ __html: data.title }}
          style={{
            // 如果设置了深色背景（非标准/蓝白模板），使用白色文字
            color: (!isStandardTemplate && !isBlueWhiteTemplate && data.backgroundColor && data.backgroundColor !== 'transparent')
              ? '#ffffff'
              : undefined
          }}
        />
      )}
      {data.video && (
        <video
          src={typeof data.video === 'string' ? data.video : data.video.url}
          className="usage-video"
          controls={(data.videoOptions ? data.videoOptions.controls !== false : true)}
          autoPlay={!!(data.videoOptions && data.videoOptions.autoplay)}
          muted={!!(data.videoOptions && data.videoOptions.muted)}
          loop={!!(data.videoOptions && data.videoOptions.loop)}
          poster={data.videoOptions && data.videoOptions.poster ? data.videoOptions.poster : undefined}
          style={{
            borderRadius: data.videoStyle && data.videoStyle.radius ? data.videoStyle.radius : 0,
            border: data.videoStyle && data.videoStyle.borderWidth ? `${data.videoStyle.borderWidth}px solid ${data.videoStyle.borderColor || '#e8eaed'}` : 'none',
            height: data.videoStyle && data.videoStyle.height ? data.videoStyle.height : undefined
          }}
        />
      )}
    </div>
  );
}
